export const AiPanelSidebarData = [
  {
    title: "EXAM NAME",
    subNav: [
      {
        title: "CREATE",
        path: "createexam",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE",
        path: "editdeleteexam",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "SUB EXAM NAME",
    subNav: [
      {
        title: "CREATE",
        path: "createsubexam",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE",
        path: "editdeletesubexam",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "EXAM STREAM",
    subNav: [
      {
        title: "CREATE",
        path: "createparentcourse",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE",
        path: "editdeleteparentcourse",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "SUBJECT",
    subNav: [
      {
        title: "CREATE",
        path: "createsubject",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE",
        path: "editdeletesubject",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "TOPIC",
    subNav: [
      {
        title: "CREATE",
        path: "createtopic",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE",
        path: "editdeletetopic",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "SUB-TOPIC",
    subNav: [
      {
        title: "CREATE",
        path: "createsubtopic",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE",
        path: "editdeletesubtopic",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "PATTERN",
    subNav: [
      {
        title: "CREATE",
        path: "createpattern",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE",
        path: "editdeletepattern",
        cName: "sub-nav",
      },
    ],
  },
  // {
  //   title: "SUBJECT FILE UPLOAD",
  //   link: "subjectFileUpload",
  // },
  // {
  //   title: "DISPLAY UPLOADED EXTRACTED DATA",
  //   link: "displayUploadedExtractedData",
  // },
  // {
  //   title: "PYQ FILE UPLOAD",
  //   link: "pyqFileUpload",
  // },
  {
    title: "KNOWLEDGE BASE",
    subNav: [
      {
        title: "SYLLABUS & PATTERN UPLOAD",
        path: "knowledgeBaseUpload",
        cName: "sub-nav",
      },
      {
        title: "STRUCTURED KNOWLEDGE",
        path: "structuredKnowledge",
        cName: "sub-nav",
      },
      {
        title: "BOOKS KNOWLEDGE UPLOAD",
        path: "subjectwiseKnowledgeBaseUpload",
        cName: "sub-nav",
      },

      {
        title: "BOOK Zip FILE Upload",
        path: "CropImageZipUpload",
        cName: "sub-nav",
      },
      {
        title: "BOOK KNOWLEDGE DISPLAY",
        path: "subjectWiseKnowledge",
        cName: "sub-nav",
      },

      {
        title: "PYQ KNOWLEDGE BASE",
        path: "pyqKnowledgeBaseUpload",
        cName: "sub-nav",
      },
      {
        title: "PYQ WEIGHTAGE Analytics",
        path: "pyqAnalyticsDashboard",
        cName: "sub-nav",
      },
      {
        title: "PYQ QUESTION EXTRACTION",
        path: "pyqQuestionExtraction",
        cName: "sub-nav",
      },
      // {
      //   title: "PARTWISE QUESTION DATA",
      //   path: "partwiseQuestionData",
      //   cName: "sub-nav",
      // },
      {
        title: "PYQ EXTRACTION",
        path: "pyqExtraction",
        cName: "sub-nav",
      },
    ],
  },

  {
    title: "AI EXAM SET",
    subNav: [
      {
        title: "EXAM GENERATE",
        path: "AIExamSet",
        cName: "sub-nav",
      },
      {
        title: "GENERATED EXAM SETS",
        path: "generatedSets",
        cName: "sub-nav",
      },

      {
        title: "EXAM ExTRACTOR",
        path: "questionExtractor",
        cName: "sub-nav",
      },
      {
        title: "QUESTIONS REVIEW",
        path: "questionsReview",
        cName: "sub-nav",
      },
    ],
  },
  // {
  //   title: "STRUCTURED KNOWLEDGE",
  //   link: "structuredKnowledge",
  // },
  {
    title: "MOVEMENTS OF MEETING",
    subNav: [
      {
        title: "MOVEMENTS OF MEETING",
        path: "movementsOfMeeting",
        cName: "sub-nav",
      },
      {
        title: "EDIT/DELETE",
        path: "editMovementsOfMeeting",
        cName: "sub-nav",
      },
    ],
  },
];
export const AiEmpSidebarData = [
  {
    title: "EMPLOYEE DETAILS",
    subNav: [
      {
        title: "Dashboard",
        path: "dashboard",
        cName: "sub-nav",
      },
      {
        title: "My Profile",
        path: "userProfile",
        cName: "sub-nav",
      },
      {
        title: "Policies",
        path: "policy",
        cName: "sub-nav",
      },
      {
        title: "KRA/KPI",
        path: "kraKpi",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "EXAM NAME",
    subNav: [
      {
        title: "CREATE",
        path: "createexam",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE",
        path: "editdeleteexam",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "SUB EXAM NAME",
    subNav: [
      {
        title: "CREATE",
        path: "createsubexam",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE",
        path: "editdeletesubexam",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "EXAM STREAM",
    subNav: [
      {
        title: "CREATE",
        path: "createparentcourse",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE",
        path: "editdeleteparentcourse",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "SUBJECT",
    subNav: [
      {
        title: "CREATE",
        path: "createsubject",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE",
        path: "editdeletesubject",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "TOPIC",
    subNav: [
      {
        title: "CREATE",
        path: "createtopic",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE",
        path: "editdeletetopic",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "SUB-TOPIC",
    subNav: [
      {
        title: "CREATE",
        path: "createsubtopic",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE",
        path: "editdeletesubtopic",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "PATTERN",
    subNav: [
      {
        title: "CREATE",
        path: "createpattern",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE",
        path: "editdeletepattern",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "SUBJECT FILE UPLOAD",
    link: "subjectFileUpload",
  },
  {
    title: "DISPLAY UPLOADED EXTRACTED DATA",
    link: "displayUploadedExtractedData",
  },
  {
    title: "PYQ FILE UPLOAD",
    link: "pyqFileUpload",
  },
  {
    title: "KNOWLEDGE BASE UPLOAD",
    link: "knowledgeBaseUpload",
  },
  {
    title: "SUBJECTWISE KNOWLEDGE BASE UPLOAD",
    link: "subjectwiseKnowledgeBaseUpload",
  },
  {
    title: "Subject Wise Knowledge",
    link: "subjectWiseKnowledge",
  },
  {
    title: "PYQ KNOWLEDGE BASE UPLOAD",
    link: "pyqKnowledgeBaseUpload",
  },
  {
    title: "PYQ QUESTION EXTRACTION",
    link: "pyqQuestionExtraction",
  },
  {
    title: "PYQ EXTRACTION",
    link: "pyqExtraction",
  },
  {
    title: "AI EXAM SET",
    link: "AIExamSet",
  },
  {
    title: "AI GENERATED SETS",
    link: "generatedSets",
  },
  {
    title: "AI QUESTIONS REVIEW",
    link: "questionsReview",
  },
  {
    title: "STRUCTURED KNOWLEDGE",
    link: "structuredKnowledge",
  },
  {
    title: "MOVEMENTS OF MEETING",
    subNav: [
      {
        title: "MOVEMENTS OF MEETING",
        path: "movementsOfMeeting",
        cName: "sub-nav",
      },
      {
        title: "EDIT/DELETE",
        path: "editMovementsOfMeeting",
        cName: "sub-nav",
      },
    ],
  },
];
